'use strict';

(function() {
	angular.module('onboarding.common')
		.directive('cobPhoneNumberInput', cobPhoneNumberInput);

	cobPhoneNumberInput.$inject = ['$filter', '$browser'];

	var $filter, $browser;

	function cobPhoneNumberInput(_filter_, _browser_) {
		$filter = _filter_;
		$browser = _browser_;

		return {
			require: 'ngModel',
			link: function($scope, $element, $attrs, ngModelCtrl) {
				var listener = function() {
					var value = $element.val().replace(/[^0-9]/g, '');
					$element.val($filter('tel')(value, false));
				};

				// This runs when we update the text field
				ngModelCtrl.$parsers.push(function(viewValue) {
					if (viewValue)
						return viewValue.replace(/[^0-9]/g, '').slice(0, 10);
					else
						return viewValue;
				});

				// This runs when the model gets updated on the scope directly and keeps our view in sync
				ngModelCtrl.$render = function() {
					$element.val($filter('tel')(ngModelCtrl.$viewValue, false));
				};

				$element.bind('change', listener);
				$element.bind('keydown',
					function(event) {
						var charCode = (event.which) ? event.which : event.keyCode;
						var key = event.keyCode;

						switch (charCode) {
						case 8: //backspace
						case 35: //end
						case 36: //home
						case 37: //left arrow
						case 39: //right arrow
						case 46: //delete
							return;
						}

						if (!/^[0-9]$/.test(String.fromCharCode(charCode))) {
							if (!key >= 96 && !key <= 105) {
								event.preventDefault();
							}
						}

						// If the keys include the TAB, CTRL, SHIFT, ALT, or META keys, 10 key pad, or the arrow keys, do nothing.
						// This lets us support copy and paste too
						if ((key === 91) || (15 < key && key < 19) || (37 <= key && key <= 40) || (key === 9)) {
							return;
						}

						$browser.defer(listener); // Have to do this or changes don't get picked up properly
					});

				$element.bind('paste cut',
					function() {
						$browser.defer(listener);
					});
			}

		};
	}

})();
